export default [
  {
    cardColor: 'white',
    avatarUrl: 'endre-barath-jr.jpg',
    personName: 'Endre Barath Jr.',
    stars: '4.5',
    description:
      'Berkshire Hathaway Homeservices California Properties - Beverly Hills',
    locationName: 'LA',
    testimonialContent:
      'Thank you! You guys are awesome. Will spread the word.',
  },
  {
    cardColor: 'blue',
    avatarUrl: 'stanwiebe.jpg',
    personName: 'Stan Weibe',
    stars: '5',
    description: 'RE/MAX Little Oak Realty',
    locationName: 'Abbotsford',
    testimonialContent:
      'People that follow me, they can see that I’m giving them good information that looks good, is up to date, that they can use and ask me more questions if they want to. The quality of what you’re doing is excellent. I have no question-it’s very very nice.',
  },
  {
    cardColor: 'white',
    avatarUrl: 'carmenabe.jpg',
    personName: 'Carmen Abraham',
    stars: '4.5',
    description: 'Keller Williams Realty',
    locationName: 'Los Angeles, CA',
    testimonialContent:
      'Excellent customer service and great products, they have awesome tools for realtors.',
  },
  {
    cardColor: 'blue',
    avatarUrl: 'jeanesop.jpg',
    personName: 'Jean E. Esop',
    stars: '5',
    description: 'Coldwell Banker Village Properties',
    locationName: 'San Diego',
    testimonialContent:
      'Your videos are beyond amazing and on point regarding content. You are so impressive as an artist and short film maker! Thank you for providing us with your AWESOME, INFORMATIVE VIDEOS!',
  },
  {
    cardColor: 'white',
    avatarUrl: 'craig-whitlock.jpg',
    personName: 'Craig Whitlock',
    stars: '5',
    description: 'Coldwell Banker Realty Brentwood',
    locationName: 'Los Angeles, CA',
    testimonialContent:
      'You give me the ability to present quality content. I regard you guys as my primary resource for content. Your videos are done with the quality and professionalism that’s consistent with the level of information that I want to share with my universe.',
  },
  {
    cardColor: 'blue',
    avatarUrl: 'marcello-cuelo-sq.jpg',
    personName: 'Marcello Cuello',
    stars: '5',
    description: 'RE/MAX WEST EXPERTS',
    locationName: 'Kleinburg, Ontario',
    testimonialContent:
      'Making calls is great but I like using Roomvu videos to connect with clients through email. I can use these videos to let clients know that I’m still thinking about them, taking the initiative to send them informative videos.',
  },
  {
    cardColor: 'white',
    avatarUrl: 'susangupta.jpg',
    personName: 'Susan Gupta',
    stars: '5',
    description: 'Berkshire Hathaway HomeServices California Properties',
    locationName: 'Toronto',
    testimonialContent:
      'I reconnected. Love your work. I am realigning myself and will be moving to branding with your firm in the next 6 months.',
  },
  {
    cardColor: 'blue',
    avatarUrl: 'stevespiro.png',
    personName: 'Steven James Spiro',
    stars: '4.5',
    description: 'Re/Max Gold Daly City',
    locationName: 'Los Angeles, CA',
    testimonialContent: 'Oh and I love your service, have a great day!',
  },
  {
    cardColor: 'white',
    avatarUrl: 'douglasnguyen.png',
    personName: 'Douglas Nguyen',
    stars: '4.5',
    description: 'Turnaround Asset Advisory',
    locationName: 'LA',
    testimonialContent: 'I love your work',
  },
  {
    cardColor: 'blue',
    avatarUrl: 'Roger-Rampuri.png',
    personName: 'Roger Rampuri',
    stars: '5',
    description: 'Sutton Centre Realty',
    locationName: 'Surrey, British Columbia',
    testimonialContent: 'I have doubled my sales last year using roomvu!',
  },
  {
    cardColor: 'white',
    avatarUrl: 'Sam-Ajgaonkar.png',
    personName: 'Sam Ajgaonkar',
    stars: '5',
    description: 'EXP REALTY',
    locationName: 'Burnaby, British Columbia',
    testimonialContent:
      'Using a free plan on roomvu, I just got a lead who wants to sell his home next week!',
  },
  {
    cardColor: 'blue',
    avatarUrl: 'Baldev Thind.jpg',
    personName: 'Baldev Thind',
    stars: '5',
    description: 'Century 21 President Realty Inc',
    locationName: 'Brampton, Ontario',
    testimonialContent:
      "I don't know why I did not use roomvu before. it is a great platform!",
  },
  {
    cardColor: 'white',
    avatarUrl: 'Edna Talavera.jpg',
    personName: 'Edna Talavera',
    stars: '5',
    description: 'eXp Realty',
    locationName: 'Miami, Florida',
    testimonialContent:
      'I have been using roomvu for over a year now. It really works and I really enjoy the program.',
  },
  {
    cardColor: 'blue',
    avatarUrl: 'Marilyn Miller.jpg',
    personName: 'Marilyn Miller',
    stars: '5',
    description: 'eXp Realty',
    locationName: 'Jamaica, New York',
    testimonialContent:
      "I am using roomvu for all my social media, It's been great. It really works.",
  },
  {
    cardColor: 'white',
    avatarUrl: 'Hector Romo.jpg',
    personName: 'Hector Romo',
    stars: '5',
    description: 'EHomes Real Estate',
    locationName: 'Los Angeles, California',
    testimonialContent:
      "I like roomvu's Pro plan; I have been using it for a while. roomvu's support is awesome!",
  },
  {
    cardColor: 'blue',
    avatarUrl: 'Roy Wang.jpg',
    personName: 'Roy Wang',
    stars: '5',
    description: 'Oakwyn Realty Ltd',
    locationName: 'Vancouver, British Columbia',
    testimonialContent: 'I like roomvu. I think it works!',
  },
  {
    cardColor: 'blue',
    avatarUrl: 'Barb Cole.jpg',
    personName: 'Barb Cole',
    stars: '5',
    description: 'Coldwell Banker Realty',
    locationName: 'Frisco, Texas',
    testimonialContent: 'I chose Platinum and I love how it works.',
  },
  {
    cardColor: 'white',
    avatarUrl: 'Roger Rampuri - PREC.jpg',
    personName: 'Roger Rampuri - PREC',
    stars: '5',
    description: 'Sutton Centre Realty',
    locationName: 'Burnaby, British Columbia',
    testimonialContent: 'I have doubled my sales since last year using roomvu!',
  },
  {
    cardColor: 'blue',
    avatarUrl: 'Lance Cangey.jpg',
    personName: 'Lance Cangey',
    stars: '5',
    description: 'Scofield Realty Inc',
    locationName: 'Las Vegas, Nevada',
    testimonialContent:
      'I have used a roomvu free account and I am impressed with the results,  I have gotten 6000 people to view my posts.',
  },
  {
    cardColor: 'white',
    avatarUrl: 'Martha Wright.jpg',
    personName: 'Martha Wright',
    stars: '5',
    description: 'eXp Realty',
    locationName: 'Thurston County, Washington',
    testimonialContent:
      'I have tried so many programs this is the most complete one. I think it is the best program for the money. ',
  },
  {
    cardColor: 'blue',
    avatarUrl: 'Kevin Sood.jpg',
    personName: 'Kevin Sood',
    stars: '5',
    description: 'Amex Fraseridge Realty',
    locationName: 'Marpole, British Columbia',
    testimonialContent:
      'Thank you so much for social media training, I learnt so much from Sam and I am now going to work more on my social media with roomvu doing the rest.7',
  },
  {
    cardColor: 'white',
    avatarUrl: 'Wally Sears.jpg',
    personName: 'Wally Sears',
    stars: '5',
    description: 'Berkshire Hathaway',
    locationName: 'Jacksonville, Florida',
    testimonialContent:
      'I think roomvu works because it has hyper-local videos.',
  },
  {
    cardColor: 'blue',
    avatarUrl: 'Nadine Diaz.jpg',
    personName: 'Nadine Diaz',
    stars: '5',
    description: 'NV Real Estate',
    locationName: 'Jacksonville, Florida',
    testimonialContent:
      "Sam's training on social media was very helpful and informative. Lots of great recommendations about different social media platforms and how they work. ",
  },
  {
    cardColor: 'white',
    avatarUrl: 'Christine Richard.jpg',
    personName: 'Christine Richard',
    stars: '5',
    description: 'Coldwell Banker Mountain Central',
    locationName: 'Calgary, Alberta',
    testimonialContent:
      'I have been using roomvu for a while and I have been getting 4 times more engagement than Back at You Media!',
  },
  {
    cardColor: 'blue',
    avatarUrl: 'Mike Grue.jpg',
    personName: 'Mike Grue',
    stars: '5',
    description: 'Century 21 Masters',
    locationName: 'Edmonton, Alberta',
    testimonialContent:
      'Everything with roomvu has been great. I really have no complaints.',
  },
  {
    cardColor: 'white',
    avatarUrl: 'Hassan Shahid.jpg',
    personName: 'Hassan Shahid',
    stars: '5',
    description: 'HH homes Realty ',
    locationName: 'Kitchener, Ontario',
    testimonialContent:
      "I joined 6 months ago. With roomvu's quality content, I have 3800 followers now. ",
  },
  {
    cardColor: 'blue',
    avatarUrl: 'Ross Lockie.jpg',
    personName: 'Ross Lockie',
    stars: '5',
    description: 'Re/Max 2000 Realty',
    locationName: 'Burnaby, British Columbia',
    testimonialContent: 'Unbelievable! roomvu is a great product. Crush it!',
  },
];
